import riskOptions from "@/data/options/mixins/riskOptions.js";
export default {
  mixins: [riskOptions],
  methods: {
    riskRatingCalc(cons, like) {
      let rate = null;
      rate = cons + like;
      return rate;
    },
    riskValueCalc(cons, like) {
      let value = null;
      // eslint-disable-next-line
      let r1 = this.getRiskValue(cons, this.riskConsequenceOptions, this.riskConsequenceValueOptions)
      // eslint-disable-next-line
      let r2 = this.getRiskValue(like, this.riskLikelihoodOptions, this.riskLikelihoodValueOptions)
      if (r1 !== null && r2 !== null) {
        value = r1 * r2;
      }
      return value;
    },
    calcRiskTotal(list) {
      let risk = 0;
      for (let i = 0; i < list.length; i++) {
        let cons = list[i].char.cons;
        let like = list[i].char.like;
        if (cons !== "" && like !== "") {
          risk = risk + this.riskValueCalc(cons, like);
        }
      }
      return risk;
    },
    getRiskValue(risk, list, solutionList) {
      let index = 0;
      let newRisk = null;
      for (let i = 0; i < list.length; i++) {
        if (risk === list[i]) {
          index = i;
          newRisk = solutionList[index];
        }
      }
      return newRisk;
    }
  },
  data() {
    return {
      valid: true
    };
  }
};
